<template>
  <div class="wrapper-section pb-10">
    <div class="section mb-0">
      <div class="section__content order">
        <h2 class="section__title">{{ $t('main-page.returned.back-to-pharmacy.title') }}</h2>
        <copay-block></copay-block>
        <deliver-progress-line :force-status="2"></deliver-progress-line>

        <div class="client_info__container">
          <promised-eta></promised-eta>
          <delivery-from v-if="orderData.client" :long="true"></delivery-from>
          <delivery-to :long="true"></delivery-to>
        </div>

        <reschedule-btn></reschedule-btn>

        <approve-type></approve-type>
        <confirmation-form></confirmation-form>
      </div>
    </div>
  </div>
  <div v-if="allowTips" class="wrapper-section" style="padding-top: 10px">
    <div class="tips-section-border">
      <tips-component></tips-component>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import CopayBlock from '@/components/_common/copay-block.vue'
import DeliverProgressLine from '@/components/MainPage/Delivering/NotConfirmed/components/delivery-progress-line.vue'
import DeliveryFrom from '@/components/_common/delivery-from.vue'
import DeliveryTo from '@/components/_common/delivery-to.vue'
import ApproveType from '@/components/_common/ApproveType/index.vue'
import ConfirmationForm from '@/components/MainPage/Delivering/NotConfirmed/components/confirmation-form.vue'
import TipsComponent from '@/components/_common/TipsComponents/tips-component.vue'
import PromisedEta from '@/components/_common/promised-eta.vue'
import RescheduleBtn from '@/components/_common/reschedule-btn.vue'

export default {
  name: 'pending-back-to-pharmacy',
  components: {
    RescheduleBtn,
    PromisedEta,
    TipsComponent,
    ConfirmationForm,
    ApproveType,
    DeliveryTo,
    DeliveryFrom,
    DeliverProgressLine,
    CopayBlock,
  },
  computed: {
    ...mapGetters(['orderData', 'allowTips']),
  },
}
</script>

<style scoped>

</style>
